export const RightArrowIcon = ({ width = 32, height = 32 }) => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-right-arrow"
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            className="primary-path"
            d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
            fill="#27292D"
        />
        <path
            className="secondary-path"
            d="M13.775 11.316a1.07 1.07 0 000 1.515l4.17 4.17-4.17 4.17a1.07 1.07 0 101.516 1.515l4.932-4.933a1.07 1.07 0 000-1.515l-4.932-4.933a1.08 1.08 0 00-1.516.01z"
            fill="#fff"
        />
    </svg>
);
